export default __webpack_public_path__ + "static/media/mailing-icon.8d42b73a.svg";